import React, { useContext, useEffect, useState } from "react";
import FileList from "../fileList/fileList";
import ClientTable from "../clientTable/clientTable";
import { Button } from "react-bootstrap";
import RejectionHistoryTable from "../rejectionHistoryTable/rejectionHistoryTable";
import SuccessModal from "../modals/successModal/successModal";
import RejectModal from "../modals/rejectModal/rejectModal";
import EditClientModal from "../modals/editClientModal/editClientModal";
import EditSuccessModal from "../modals/editClientModal/editSuccessModal";
import ReportsService from "../../../../../../services/reports-service";
import { IdentityContext } from "../../../../../../context/identity-context";

const ReportDetails = ({ report }) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditSuccessModal, setShowEditSuccessModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const { user } = useContext(IdentityContext);
  const reportService = new ReportsService();
  const makerName = user.attributes["custom:display_name"];

  const handleSendReport = async () => {
    try {
      await reportService.adcuMakerSubmitReport(
        report.reportHash,
        report.interestPaymentDate,
        makerName
      );
      setShowSuccessModal(true); // Show success modal if API call succeeds
    } catch (error) {
      console.error("Error sending report:", error);
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    window.location.reload(); // Reload page on success
  };

  const handleRejectReport = () => {
    setShowRejectModal(true);
  };

  // === EDIT FLOW ===
  const handleOpenEditModal = (client) => {
    setSelectedClient(client);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedClient(null);
  };

  const handleSaveClientIds = async ({ bpId, amount }) => {
    try {
      await reportService.adcuMakerEditClientInfo(
        report.reportHash,
        bpId,
        amount
      );
      // Success: close edit modal, show success confirmation, schedule reload
      setShowEditModal(false);
      setSelectedClient(null);
      setShowEditSuccessModal(true);

      // Auto-reload after 5 seconds
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    } catch (error) {
      console.error("Error updating client identifiers:", error);
      // You could show a toast or error modal here if desired
    }
  };

  const handleCloseEditSuccess = () => {
    setShowEditSuccessModal(false);
    window.location.reload();
  };

  const isDisabled = report.status !== "Report Available";
  
  const files = [report.documents.pdf1, report.documents.pdf2, report.documents.otherDocuments]

  return (
    <>
      <FileList files={files} report={report} />
      <ClientTable
        clients={report.clients}
        onEdit={handleOpenEditModal}
        // editDisabled={isDisabled} // uncomment if you want to restrict
      />
      <RejectionHistoryTable rejectionHistory={report.rejectionHistory} />
      <div className="d-flex justify-content-end">
        <Button
          variant="danger"
          className="me-2"
          onClick={handleRejectReport}
          disabled={isDisabled}
        >
          Return
        </Button>
        <Button
          variant="primary"
          className="mx-2"
          onClick={handleSendReport}
          disabled={isDisabled}
        >
          Send Report
        </Button>
      </div>

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleSuccessModalClose}
        report={report}
      />
      <RejectModal
        show={showRejectModal}
        handleClose={() => setShowRejectModal(false)}
        report={report}
      />

      <EditClientModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        onSave={handleSaveClientIds}
        client={selectedClient}
      />
      <EditSuccessModal
        show={showEditSuccessModal}
        onClose={handleCloseEditSuccess}
      />
    </>
  );
};

export default ReportDetails;